var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCameraBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.557,
    height: 15.363,
    viewBox: "0 0 17.557 15.363",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-camera",
    "data-name": "Icon awesome-camera",
    d: "M17.558,6.091v9.876a1.646,1.646,0,0,1-1.646,1.646H1.646A1.646,1.646,0,0,1,0,15.967V6.091A1.646,1.646,0,0,1,1.646,4.445H4.664l.422-1.128A1.644,1.644,0,0,1,6.625,2.25h4.3a1.644,1.644,0,0,1,1.54,1.066l.425,1.128h3.018A1.646,1.646,0,0,1,17.558,6.091Zm-4.664,4.938a4.115,4.115,0,1,0-4.115,4.115A4.118,4.118,0,0,0,12.894,11.029Zm-1.1,0A3.018,3.018,0,1,1,8.779,8.011,3.022,3.022,0,0,1,11.8,11.029Z",
    transform: "translate(0 -2.25)",
    fill: "#1492e6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCameraBlue);
export default __webpack_public_path__ + "static/media/icon-camera-blue.456746f47cf87f13ef166812d058bdd9.svg";
export { ForwardRef as ReactComponent };